import "./service-categories.scss";

import PageTitleBreadcrumb from "@frontend/js/Components/Shared/PageTitleBreadcrumb/PageTitleBreadcrumb";
import ServicesCards from "@frontend/js/Components/Site/ServicesCards/ServicesCards";
import MetaHead from "@frontend/js/Components/Shared/MetaHead/MetaHead";
import SiteLayout from "@frontend/js/Layouts/SiteLayout";
import useT from "@frontend/js/hooks/useT";
import { usePage } from "@inertiajs/react";

export default function ServiceCategories({
    page,
    collection,
    servicesWithoutCategory = null,
    meta = {
        title: "",
        description: "",
    },
}) {
    const { t } = useT("site");
    const pageProps = usePage().props;
    const locale = pageProps.currentLocale;
    const categories = collection?.data || [];
    const servicesWithoutCategoryList = servicesWithoutCategory?.data || [];
    const content = page?.content?.[locale] || "";
    const pageTitle = page?.title?.[locale] || "";

    return (
        <>
            <MetaHead meta={meta} />

            <SiteLayout>
                <div className="services page-shell">
                    <div className="services__container">
                        <PageTitleBreadcrumb title={pageTitle} />

                        <div className="servicesCards">
                            <ServicesCards
                                cards={categories}
                                href={(item) => item.href}
                            />

                            {servicesWithoutCategoryList.length > 0 && (
                                <ServicesCards
                                    cards={servicesWithoutCategoryList}
                                    hideLabel={true}
                                    href={(item) => item.href}
                                />
                            )}
                        </div>

                        <div className="services__container__text">
                            <h2>{t("services-description-title")}</h2>
                            <div className="services__container__text__description">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: content,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </SiteLayout>
        </>
    );
}
